import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AppData } from '../models/data.model';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { CultureService } from './culture.service';


@Injectable()
export class StartupService {
  public websiteName: string;
  private cultureService: CultureService;
  private culture: string;
  private errorModalSource: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public errorModalState: Observable<boolean> = this.errorModalSource.asObservable();

  private _startupData: AppData;
  get startupData(): AppData {
    return this._startupData;
  }

  constructor(private httpClient: HttpClient) {
    // console.log(this.cultureService.getCulture()); ${this.cultureService.getCulture()}  ,private cultureService:CultureService
  }

  // This is the method you want to call at bootstrap
  // Important: It should return a Promise
  public async load(): Promise<any> {
    this.websiteName = environment.siteName;
    this._startupData = null;

    this.culture = window.location.href.split('/')[3];

    // way to get the production CA url to go to the correct culture
    // if (this.culture === '' && window.location.hostname === 'projectpro.olympicstains.ca') {
    //   window.location.href = '/en-ca/welcome';
    // } else if (this.culture === '') {
      // window.location.href = '/en-us/welcome';
    // }

    return await this.httpClient
      .get(`${environment.apiUrl}/data/${this.websiteName}/${this.culture || 'en-us'}`)
      .toPromise()
      .then((data: AppData) => this._startupData = data)
      .catch((err: any) => Promise.resolve());
  }

  setErrorModal(value: boolean) {
    this.errorModalSource.next(value);
  }

  getPostalRouterLink(): string[] {
    return ['/'].concat(this._startupData.Routes.filter(x => x.name.toLowerCase() === 'postal')[0]
      .path.toLowerCase()
      .replace(':website', this.websiteName)
      .replace(':culture', this.culture).split('/'));
  }

  getProductRouterLink(nodeAlias: string) {
    return ['/'].concat(this._startupData.Routes.filter(x => x.name.toLowerCase() === 'productrecommendation')[0]
      .path.toLowerCase()
      .replace(':website', this.websiteName)
      .replace(':nodealias', nodeAlias)
      .replace(':culture', this.culture).split('/'));
  }

  getStepRouterLink(): string[] {
    const routingArray = ['/'].concat(this._startupData.Routes.filter(x => x.name.toLowerCase() === 'step')[0]
      .path.toLowerCase()
      .replace(':website', this.websiteName)
      .replace(':culture', this.culture).split('/'));
    routingArray.push('168'); // TODO why 168?
    return routingArray;
  }

  getStepWithNodeRouterLink(nodeId: string | number): string[] {
    return ['/'].concat(this._startupData.Routes.filter(x => x.name.toLowerCase() === 'stepwithnode')[0]
      .path.toLowerCase()
      .replace(':website', this.websiteName)
      .replace(':culture', this.culture)
      .replace(':nodeid', < string > nodeId).split('/'));
  }

  getStepConfirmationRouterLink(nodeId: string | number) {
    return ['/'].concat(this._startupData.Routes.filter(x => x.name.toLowerCase() === 'answerconfirmation')[0]
      .path.toLowerCase()
      .replace(':website', this.websiteName)
      .replace(':nodeid', < string > nodeId)
      .replace(':culture', this.culture).split('/'));
  }
  getStepConfirmationRouterLink2(nodeId: string | number, answerConfirmationId: string | number) {
    return ['/'].concat(this._startupData.Routes.filter(x => x.name.toLowerCase() === 'answerconfirmation2')[0]
      .path.toLowerCase()
      .replace(':website', this.websiteName)
      .replace(':nodeid', < string > nodeId)
      .replace(':culture', this.culture)
      .replace(':answerconfirmationid', < string > answerConfirmationId).split('/'));
  }
  getVisualizerRouterLink() {
    return ['/'].concat(this._startupData.Routes.filter(x => x.name.toLowerCase() === 'visualizer')[0]
      .path.toLowerCase()
      .replace(':website', this.websiteName)
      .replace(':culture', this.culture).split('/'));
  }
}



// WEBPACK FOOTER //
// ./src/app/services/startup.service.ts